import CONFIG from "./../temp/config"

export let toCurrency = (number) => {
    return number.toLocaleString(
        'en-US',
        {
            style: 'currency',
            currency: 'USD'
        });
};

//Our currency format
export let toCurrencyNoDecimal = (number) => {
    return number.toLocaleString(
        'en-US',
        {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
        });
};

//Build our range values for ranged dropdowns
export let rangeKeyToRangeString = (items, key, factor = 1) => {

    let item = items[key];
    let displayString = toCurrencyNoDecimal(parseFloat(item.rangeMin)/factor) + ' - '
        + toCurrencyNoDecimal(parseFloat(item.rangeMax)/factor);

    if (!item.isRange) {
        //First item, just the value. Any other non range, add a plus to the end.
        displayString = toCurrencyNoDecimal(parseFloat(item.rangeMin)/factor);

        //If its the last item, add a + to the value
        if (items.length-1 === key) {
            displayString += '+';
        }
    }
    return displayString;
};

//Calculate yield
export let calculateYield = (amount, rate, years) => {

    return (amount * Math.pow((1 + rate), years) - amount);

};

export let charLimits = {
    default: 50,
    referralCode: 6,
    nameLast: 40,
    nameFirst: 15,
    nameMiddle: 15,
    addressStreet: 35,
    addressCity: 40,
    addressZip: 5,
    companyName: 40,
    emailAddress: 254,
    phoneNumberUS: 20,
    ssn: 11,
    tin: 10,
    idNumber: 20,
    bankRoutingNumber: 9,
    bankAccountNumber: 17,
    trustName: 30,
};

export let regex = {
    email: '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-z]{2,3}$',
    phoneNumberUS: '^\\(?(\\d{3})\\)?[- ]?(\\d{3})[- ]?(\\d{4})$',
    ssn: "^\\d{3}-?\\d{2}-?\\d{4}$",
    tin: "^\\d{2}-?\\d{7}$",
    zip: "^\\d{5}$",
    referralCode: "^[A-Za-z0-9_-]{6}$",
    idNumber: "^[A-Za-z0-9_-]{5,20}$",
    bankRoutingNumber: "^\\d{9}$",
    bankAccountNumber: "^\\d{4,17}$",
    numbers: /[\D]/g
};

export let formatting = {
    dob : "MM-DD-YYYY",
    idExpiration : "MM-DD-YYYY"
};

export let formatPhoneNumber = (phoneNumberString) => {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return match[1] + '-' + match[2] + '-' + match[3];
    }
    return null;
};

export let NassauLog = (message) => {

    if (CONFIG.logging) {

        // eslint-disable-next-line no-console
        console.log(message);
    }

};

export let NassauError = (data) => {

    if (CONFIG.logging) {

        // eslint-disable-next-line no-console
        console.error(data);
    }

};

/*
3 * (digits[0] + digits[3] + digits[6]) +
7 * (digits[1] + digits[4] + digits[7]) +
(digits[2] + digits[5] + digits[8]) % 10 === 0
 */

export const isObject = obj => {
  const type = typeof obj;
  return (type === 'function' || type === 'object') && !!obj && Object.prototype.toString.call(obj) !== '[object Array]';
}

export const isArray = obj => {
  const type = typeof obj;
  return (type === 'function' || type === 'object') && !!obj && Object.prototype.toString.call(obj) === '[object Array]';
}